module.exports = __webpack_public_path__ + "static/media/deskbanner3.489919b9.png";